<template>
  <nuxt-layout name="www">
    <u-app>
      <client-only>
        <div class="absolute" id="loading-completed">
          <span class="opacity-0">-</span>
        </div>
      </client-only>
      <nuxt-page />
    </u-app>
  </nuxt-layout>
</template>
<script lang="ts">
import * as _enum from "~/enums";
import { useSimpleSeo, DEFAULT_SEO_KEYWORDS } from "#imports";
export default {
  setup() {
    useSimpleSeo({
      title: "Incigma - Apps",
      description: "Free online tools for internet tasks.",
      keywords: [...DEFAULT_SEO_KEYWORDS],
      author: "Incigma.com",
      image: _enum.og.default
    });
  }
};
</script>
